<template>
  <div id="page-login" style="background-image: url(https://cdn.discordapp.com/attachments/733851758211629347/954057924391600218/BG.png)" class="bg-cover">
   <!--- <video-background src="https://cdn.discordapp.com/attachments/870391445176086539/870404164193239050/Slowed.mp4"
                      class="rounded-lg bg-img h-screen"> --->
      <div style="backdrop-filter: blur(12px); height: 100%;">
        <div class=" h-screen flex w-full  vx-row no-gutter items-center justify-center">
          <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4" style="max-width: 1300px;">
            <div class="vx-row no-gutter justify-center items-center">
              <div class="vx-col hidden lg:block lg:w-1/2">
                <slide-x-left-transition>
                <img alt="login" class="mx-auto" width="300px" draggable="false" v-if="transition"
                     src="https://cdn.discordapp.com/attachments/746242308084858900/859142541987151922/IP_Logo_White.png">
                </slide-x-left-transition>
              </div>

              <slide-x-left-transition>
              <div class="vx-col sm:w-full md:w-full lg:w-1/2 rounded frosted-container" v-if="transition">
                <vx-card class="bg-login-card">
                  <div slot="no-body">
                    <div class="p-12">

                      <div class="flex justify-center block lg:hidden mb-8">
                        <img alt="login" class="" width="240px" draggable="false" v-if="transition"
                             src="https://cdn.discordapp.com/attachments/746242308084858900/859142541987151922/IP_Logo_White.png">
                      </div>

                      <div class="vx-card__title ">
                        <h1 class="mb-4">Sign In</h1>
                        <p class="mb-6">Please sign in using your Intellectual Point Connect account</p>
                      </div>

                      <div class="con-tab con-slot-tabs">
                        <login-jwt></login-jwt>
                      </div>
                    </div>
                  </div>
                </vx-card>
              </div>
              </slide-x-left-transition>
            </div>
          </div>
        </div>
      </div>
    <!--- </video-background> --->
  </div>
</template>


<script>
import LoginJwt from './LoginJWT.vue'
import VideoBackground from 'vue-responsive-video-background-player'

export default {
  data () {
    return {
      transition: false
    }
  },
  components: {LoginJwt, VideoBackground},
  created () {
    delete this.$http.defaults.headers.common['Authorization']

    //Set Base URL
    this.$http.defaults.baseURL = 'https://sims-api.intellectualpoint.com/v1/'
    //    this.$http.defaults.baseURL = 'http://192.168.1.72:49538/v1/'

    if (localStorage['accessToken'] && localStorage['accessToken']) {
      this.$router.push('/dashboard')
    }

    setTimeout(() => {
      this.transition = true
    }, 50)

  }
}
</script>

<style lang="scss">


.layout--full-page {
  .bg-img {
    background-color: #050035;
    background-image: url(https://res.cloudinary.com/acloud-guru/image/fetch/q_90/https%3A%2F%2Facloudguru-content-assets-production.s3-accelerate.amazonaws.com%2F1604294943760-wallpaper-17-srgb.jpg);
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
  }

  .full-page-bg-color {
    background-color: #eff2f7;
  }
}

#page-login {
  .login-tabs-container {
    min-height: 505px;

    .con-tab {
      padding-bottom: 14px;
    }

    .con-slot-tabs {
      padding-top: 3rem;
    }
  }

  .frosted-container {
    // box-shadow: inset 0 0 2000px rgba(255, 255, 255, 0.18);
    backdrop-filter: blur(55px);
  }

  .bg-login-card {
    background: #00000094;
  }

  input {
    background-color: transparent;
  }


}

</style>
